window.BusinessShipping = (function () {

  // ========== カレンダーと同じ営業日ルール ==========

  const defaultByWeekday = {

    0: 'closed', // 日

    1: 'phone',  // 月

    2: 'store',  // 火

    3: 'closed', // 水

    4: 'store',  // 木

    5: 'store',  // 金

    6: 'store'   // 土

  };

  const weekdays = ['日', '月', '火', '水', '木', '金', '土'];

  // label = 表示用 / cutoff = 分単位（14:00 = 840）

  const overrides = {
    "2026-10-31": { type: 'short', label: '10:00~12:30<br>14:00~<strong>16:30</strong>', cutoff: 14 * 60 },

    // ===== 2026年8月 =====

    "2026-08-01": { type: 'closed', label: '休業' },

    "2026-08-03": { type: 'store',  label: '10:00~12:30<br>14:00~18:00' },

    "2026-08-08": { type: 'short',  label: '10:00~12:30<br>14:00~<strong>15:00</strong>', cutoff: 14 * 60 },

    "2026-08-10": { type: 'short',  label: '<strong>15:00</strong>~18:00', cutoff: 15 * 60 },

    "2026-08-15": { type: 'closed', label: '休業' },

    "2026-08-17": { type: 'store',  label: '10:00~12:30<br>14:00~18:00' },

    "2026-08-20": { type: 'short',  label: '10:00~12:30<br>14:00~<strong>16:00</strong>', cutoff: 14 * 60 },

    "2026-08-22": { type: 'short',  label: '10:00~12:30<br>14:00~<strong>15:00</strong>', cutoff: 14 * 60 },

    "2026-08-24": { type: 'store',  label: '10:00~12:30<br>14:00~18:00' },

    "2026-08-28": { type: 'short',  label: '<strong>14:00</strong>~18:00', cutoff: 14 * 60 },

    "2026-08-31": { type: 'store',  label: '10:00~12:30<br>14:00~18:00' },



    // ===== 2026年9月 =====

    "2026-09-01": { type: 'closed', label: '休業' },

    "2026-09-03": { type: 'short',  label: '<strong>14:00</strong>~18:00', cutoff: 14 * 60 },

    "2026-09-04": { type: 'closed', label: '休業' },

    "2026-09-07": { type: 'short',  label: '<strong>14:30~16:00</strong>', cutoff: 14 * 60 },

    "2026-09-10": { type: 'closed', label: '休業' },

    "2026-09-14": { type: 'closed', label: '休業' },

    "2026-09-15": { type: 'short',  label: '10:00~12:30<br>14:00~<strong>15:30</strong>', cutoff: 14 * 60 },

    "2026-09-19": { type: 'short',  label: '10:00~<strong>12:30</strong>', cutoff: 12 * 60 },

    "2026-09-21": { type: 'closed', label: '休業' }, 

    "2026-09-22": { type: 'closed', label: '休業' },

    "2026-09-25": { type: 'closed', label: '休業' },

    "2026-09-26": { type: 'closed', label: '休業' },

    "2026-09-27": { type: 'closed', label: '休業' },

    "2026-09-07": { type: 'short',  label: '<strong>16:00~18:00</strong>', cutoff: 14 * 60 },



    // ===== 2026年10月 =====



  "2026-10-10": { type: 'short',  label: '10:00~12:30<br>14:00~<strong>15:45</strong>', cutoff: 14 * 60 },

  "2026-10-12": { type: 'closed', label: '休業' },

  "2026-10-15": { type: 'short',  label: '<strong>17:00~18:00</strong>', cutoff: 14 * 60 },

  "2026-10-16": { type: 'closed', label: '休業' },

  "2026-10-20": { type: 'short',  label: '10:00~12:30<br>14:00~<strong>15:00</strong>', cutoff: 14 * 60 },

  "2026-10-23": { type: 'closed', label: '休業' },

    // 2026年11月以降の祝日・振替休日（内閣府公表、2027年末まで）
    // 2026年12月15〜17日：飛鳥3クルーズによる休業
    "2026-11-03": { type: 'closed', label: '休業' },
    "2026-11-23": { type: 'closed', label: '休業' },
    "2026-12-15": { type: 'closed', label: '休業' },
    "2026-12-16": { type: 'closed', label: '休業' },
    "2026-12-17": { type: 'closed', label: '休業' },
    "2027-01-01": { type: 'closed', label: '休業' },
    "2027-01-11": { type: 'closed', label: '休業' },
    "2027-02-11": { type: 'closed', label: '休業' },
    "2027-02-23": { type: 'closed', label: '休業' },
    "2027-03-21": { type: 'closed', label: '休業' },
    "2027-03-22": { type: 'closed', label: '休業' },
    "2027-04-29": { type: 'closed', label: '休業' },
    "2027-05-03": { type: 'closed', label: '休業' },
    "2027-05-04": { type: 'closed', label: '休業' },
    "2027-05-05": { type: 'closed', label: '休業' },
    "2027-07-19": { type: 'closed', label: '休業' },
    "2027-08-11": { type: 'closed', label: '休業' },
    "2027-09-20": { type: 'closed', label: '休業' },
    "2027-09-23": { type: 'closed', label: '休業' },
    "2027-10-11": { type: 'closed', label: '休業' },
    "2027-11-03": { type: 'closed', label: '休業' },
    "2027-11-23": { type: 'closed', label: '休業' },



  };





  const typeLabels = {

    store:  '10:00~12:30<br>14:00~18:00',

    short:  '時短',

    phone:  '10:00~16:00',

    closed: '休業'

  };



  // ========== ユーティリティ ==========

  function pad(n) {

    return String(n).padStart(2, '0');

  }



  function formatDate(y, m, d) {

    return `${y}-${pad(m + 1)}-${pad(d)}`;

  }



  function formatDisplayDate(date) {

    const w = weekdays[date.getDay()];

    return `${date.getMonth() + 1}月${date.getDate()}日（${w}）`;

  }



  function minutesNow(date) {

    return date.getHours() * 60 + date.getMinutes();

  }



  function getDayType(year, month, day) {

    const key = formatDate(year, month, day);

    if (overrides[key]) return overrides[key];

    const type = defaultByWeekday[new Date(year, month, day).getDay()];

    return { type: type, label: typeLabels[type] };

  }



  function isShippingDay(type) {

    return type === 'store' || type === 'short';

  }



  // 締切時刻（分）を取得

  function getCutoffMinutes(info) {

    if (typeof info.cutoff === 'number') return info.cutoff;



    if (info.type === 'store') return 14 * 60; // 14:00



    if (info.type === 'short') {

      const times = (info.label || '').match(/(\d{1,2}):(\d{2})/g) || [];

      if (times.length >= 1) {

        const last = times[times.length - 1].split(':');

        const endMin = parseInt(last[0], 10) * 60 + parseInt(last[1], 10);

        const hasAfter14 = times.some(function (t) {

          const parts = t.split(':');

          return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10) >= 14 * 60;

        });

        if (hasAfter14) return 14 * 60;

        return Math.max(0, endMin - 120); // 終了2時間前

      }

      return 14 * 60;

    }

    return null;

  }



  /**

   * 店頭在庫品の最短出荷日を計算

   */

  function japanWallDate(instant) {
    const parts = new Intl.DateTimeFormat('en-CA', {timeZone:'Asia/Tokyo', year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit', hourCycle:'h23'}).formatToParts(instant || new Date());
    const v = Object.fromEntries(parts.map(function (p) { return [p.type, p.value]; }));
    return new Date(Number(v.year), Number(v.month)-1, Number(v.day), Number(v.hour), Number(v.minute), Number(v.second));
  }

  function orderWindowText(deadline, instant) {
    const now = japanWallDate(instant);
    if (formatDate(deadline.getFullYear(), deadline.getMonth(), deadline.getDate()) === formatDate(now.getFullYear(), now.getMonth(), now.getDate())) {
      return '本日' + deadline.getHours() + ':' + pad(deadline.getMinutes()) + 'までのご注文で';
    }
    const wallTime = function (d) { return Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds()); };
    const minutes = Math.max(0, Math.floor((wallTime(deadline) - wallTime(now)) / 60000));
    if (minutes < 1) return 'あと1分未満のご注文で';
    return 'あと' + Math.floor(minutes / 60) + '時間' + (minutes % 60) + '分以内のご注文で';
  }

  function getStockShippingEstimate(now) {

    const instant = now || new Date();
    now = japanWallDate(instant);

    const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());



    for (let i = 0; i < 30; i++) {

      const d = new Date(start);

      d.setDate(start.getDate() + i);

      const y = d.getFullYear();

      const m = d.getMonth();

      const day = d.getDate();

      const info = getDayType(y, m, day);



      if (!isShippingDay(info.type)) continue;



      const cutoff = getCutoffMinutes(info);

      if (cutoff === null) continue;



      const isToday = (i === 0);

      const nowMin = minutesNow(now);



      if (isToday && nowMin >= cutoff) continue; // 締切過ぎ



      const cutoffH = Math.floor(cutoff / 60);

      const cutoffM = cutoff % 60;

      const cutoffLabel = cutoffH + ':' + pad(cutoffM);



      var message;

      if (isToday) {

        message = '本日' + cutoffLabel + 'までのご注文で本日出荷';

      } else {

        const deadline = new Date(d);
        deadline.setHours(cutoffH, cutoffM, 0, 0);
        message = orderWindowText(deadline, instant) + '\n当店出荷予定：' + formatDisplayDate(d);

      }



      return {

        date: d,

        isToday: isToday,

        cutoffLabel: cutoffLabel,

        message: message,

        displayDate: formatDisplayDate(d)

      };

    }



    return {

      date: null,

      isToday: false,

      cutoffLabel: '',

      message: '納期お問い合わせください',

      displayDate: ''

    };

  }



  /**

   * 出荷区分（sipping.sipping）と在庫から表示テキストを返す

   * 出荷区分の値: 「店頭在庫」「メーカー直送」「お取り寄せ」

   */

  const brandDeliveryRules = {
    cec: {
      method: 'direct', stockKnown: false,
      cutoffMinutes: 720, acceptsPhoneMonday: true,
      directExcludedVariantIds: ['47235631874327'],
      routeNote: '',
      stockNote: 'メーカーに在庫がある場合の目安です。'
    },
    ortofon: {
      directSource: 'オルトフォンジャパン株式会社',
      method: 'direct', stockKnown: true, stockSupplier: 'ortofon',
      cutoffMinutes: 720, acceptsPhoneMonday: true, directExcludedVariantIds: [],
      routeNote: '国内仕入先（メース・完実電気など）経由となる場合があります。'
    },
    audioreplas: {
      directSource: 'オーディオリプラス株式会社',
      method: 'direct',
      stockKnown: false,
      weeklyShipmentDay: 2,
      cutoffMinutes: 1080,
      acceptsPhoneMonday: true,
      directExcludedVariantIds: [],
      stockNote: 'メーカーに在庫がある場合の目安です。'
    },
    phasemation: {
      directSource: '協同電子エンジニアリング株式会社',
      method: 'direct',
      stockKnown: true,
      cutoffMinutes: 720,
      acceptsPhoneMonday: true,
      directExcludedVariantIds: []
    },
    acousticrevive: {
      directSource: '関口機械販売株式会社',
      method: 'direct',
      stockKnown: true,
      stockSupplier: 'acoustic_revive_kanjitsu',
      cutoffMinutes: 720,
      acceptsPhoneMonday: true,
      directExcludedVariantIds: ['49635045179671'],
      stockNote: 'メーカーに在庫がある場合の目安です。'
    }
  };

  function getBrandDeliveryRule(opts) {
    const key = String(opts.vendor || '').normalize('NFKC').toLowerCase().replace(/[.\s・･_-]/g, '');
    return brandDeliveryRules[key] || null;
  }

  function isBrandDirect(opts) {
    if(opts.manufacturerStock?.supplier === 'dm') return false;
    const rule = getBrandDeliveryRule(opts);
    return !!rule && rule.method === 'direct' && !rule.directExcludedVariantIds.includes(String(opts.variantId || ''));
  }

  function getBrandDirectEstimate(rule, instant) {
    const now = japanWallDate(instant);
    const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const makerDay = day => dmHolidayYears.has(day.getFullYear()) && day.getDay() !== 0 && day.getDay() !== 6 && !dmHolidays.has(formatDate(day.getFullYear(), day.getMonth(), day.getDate()));
    const accepts = day => {
      const info = getDayType(day.getFullYear(), day.getMonth(), day.getDate());
      return isShippingDay(info.type) || (rule.acceptsPhoneMonday && day.getDay() === 1 && info.type === 'phone');
    };
    const nextAcceptance = day => {
      for (let n = 1; n < 60; n++) {
        const candidate = new Date(day); candidate.setDate(candidate.getDate() + n);
        if (!dmHolidayYears.has(candidate.getFullYear())) return null;
        if (makerDay(candidate) && accepts(candidate)) return candidate;
      }
      return null;
    };
    if (Number.isInteger(rule.weeklyShipmentDay)) {
      for (let i = 0; i < 60; i++) {
        const day = new Date(start); day.setDate(start.getDate() + i);
        if (!dmHolidayYears.has(day.getFullYear())) return null;
        if (day.getDay() !== rule.weeklyShipmentDay || !makerDay(day)) continue;
        for (let back = 1; back < 60; back++) {
          const deadline = new Date(day); deadline.setDate(day.getDate() - back);
          if (!dmHolidayYears.has(deadline.getFullYear())) return null;
          const info = getDayType(deadline.getFullYear(), deadline.getMonth(), deadline.getDate());
          if (!isShippingDay(info.type) && info.type !== 'phone') continue;
          deadline.setHours(18, 0, 0, 0);
          if (now < deadline) return {date: day, deadline};
          break;
        }
      }
      return null;
    }
    const tomorrow = new Date(start); tomorrow.setDate(tomorrow.getDate() + 1);
    if (makerDay(start) && accepts(start) && makerDay(tomorrow) && !accepts(tomorrow) && minutesNow(now) >= rule.cutoffMinutes) {
      const deadline = new Date(minutesNow(now) < 1080 ? start : tomorrow);
      deadline.setHours(minutesNow(now) < 1080 ? 18 : 12, 0, 0, 0);
      return {date: tomorrow, latestDate: minutesNow(now) < 1080 ? null : nextAcceptance(tomorrow), deadline};
    }
    const yesterday = new Date(start); yesterday.setDate(yesterday.getDate() - 1);
    if (makerDay(start) && !accepts(start) && makerDay(yesterday) && accepts(yesterday) && minutesNow(now) < 720) {
      const deadline = new Date(start); deadline.setHours(12, 0, 0, 0);
      return {date: start, latestDate: nextAcceptance(start), deadline};
    }
    for (let i = 0; i < 60; i++) {
      const day = new Date(start);
      day.setDate(start.getDate() + i);
      if (!dmHolidayYears.has(day.getFullYear())) return null;
      if (day.getDay() === 0 || day.getDay() === 6 || dmHolidays.has(formatDate(day.getFullYear(), day.getMonth(), day.getDate()))) continue;
      const info = getDayType(day.getFullYear(), day.getMonth(), day.getDate());
      const acceptsOrders = isShippingDay(info.type) || (rule.acceptsPhoneMonday && day.getDay() === 1 && info.type === 'phone');
      if (!acceptsOrders || (i === 0 && minutesNow(now) >= rule.cutoffMinutes)) continue;
      const deadline = new Date(day);
      deadline.setHours(Math.floor(rule.cutoffMinutes / 60), rule.cutoffMinutes % 60, 0, 0);
      return {date: day, deadline: deadline};
    }
    return null;
  }

  function getExternalStockText(opts) {
    const text = getExternalStockBaseText(opts);
    const rule = getBrandDeliveryRule(opts);
    if (!rule || !isBrandDirect(opts)) return text;
    const lines = text.split('\n');
    if (rule.directSource && lines[0] === 'メーカー直送') lines.splice(1, 0, '直送元：' + rule.directSource);
    const routeNote = rule.routeNote ?? '国内仕入先（メース・完実電気など）経由となる場合があります。';
    let routeDate = '';
    const stock = opts.manufacturerStock;
    if (!String(opts.deliveryNote || '').trim() && stock && stock.supplier === 'ortofon' && ['available', 'limited'].includes(stock.status) && !/予約順/.test(stock.next_arrival || '')) {
      const direct = getBrandDirectEstimate(rule, opts.now);
      const first = direct && getMaceShippingEstimate(direct.date);
      const last = direct && direct.latestDate && getMaceShippingEstimate(direct.latestDate);
      if (first) routeDate = 'メース経由の場合の出荷予定：' + formatDisplayDate(first) + (last ? '～' + formatDisplayDate(last) : '');
    }
    const dispatchIndex = lines.findIndex(line => line.startsWith('メーカー出荷目安：'));
    if (routeDate && dispatchIndex >= 0) lines.splice(dispatchIndex + 1, 0, routeDate);
    const noteIndex = lines.findIndex(line => /^(出荷日は目安|出荷予定日は目安|メーカーに在庫がある場合の目安)/.test(line));
    if (noteIndex >= 0) lines.splice(noteIndex, lines.length - noteIndex, routeNote + lines.slice(noteIndex).join(''));
    else if (routeNote) lines.push(routeNote);
    return lines.join('\n');
  }

  function getMaceShippingEstimate(manufacturerDispatchDate) {
    for (let i = 1; i < 60; i++) {
      const day = new Date(manufacturerDispatchDate); day.setDate(day.getDate() + i);
      if (!dmHolidayYears.has(day.getFullYear())) return null;
      if (day.getDay() !== 0 && day.getDay() !== 6 && !dmHolidays.has(formatDate(day.getFullYear(), day.getMonth(), day.getDate()))) return day;
    }
    return null;
  }

  function getExternalStockBaseText(opts) {
    if(opts.manufacturerStock?.supplier === 'dm') return getManufacturerStockText(opts.manufacturerStock, opts.now);
    const manual = String(opts.deliveryNote || '').trim();
    if (manual) {
      const method = isBrandDirect(opts) || String(opts.shippingType || '').includes('メーカー直送') ? 'メーカー直送' : 'お取り寄せ';
      return method + '\n' + manual + '\n' + (method === 'メーカー直送' ? directEstimateNote(opts) : '納期は目安です。状況により遅れる場合があります。');
    }
    const rule = getBrandDeliveryRule(opts);
    if (rule) {
      if (!isBrandDirect(opts)) return 'お取り寄せ（QR-8ばら売りはメーカー直送対象外）\n納期お問い合わせください';
      if (rule.stockKnown) {
        const stock = opts.manufacturerStock;
        const description = stock && stock.supplier === (rule.stockSupplier || 'phasemation') ? getManufacturerStockText(stock, opts.now) : '';
        if (!description && stock?.supplier === 'acoustic_revive_kanjitsu' && stock.status === 'unknown' && stock.conditional_dispatch === true) {
          const estimate = getBrandDirectEstimate(rule, opts.now);
          const conditional = estimate ? 'メーカーに在庫がある場合の出荷目安：' + formatDisplayDate(estimate.date) + (estimate.latestDate ? '～' + formatDisplayDate(estimate.latestDate) : '') + '頃' : 'メーカーに在庫がある場合の出荷目安：お問い合わせください';
          return 'メーカー直送\nメーカー在庫・納期不明／お問い合わせください\n' + conditional + '\n在庫確認後に正式な出荷予定をご案内します。\n' + directEstimateNote(opts);
        }
        if (!description) return 'メーカー直送\n' + (stock && stock.supplier === (rule.stockSupplier || 'phasemation') && stock.next_arrival ? '納期目安：' + stock.next_arrival + '\n' : '') + '納期お問い合わせください\n' + directEstimateNote(opts);
        const details = description.replace(/^お取り寄せ（([^）]+)）\s*/, '$1　').split('\n');
        if (['available', 'limited'].includes(stock.status) && !/予約順/.test(stock.next_arrival || '')) {
          const estimate = getBrandDirectEstimate(rule, opts.now);
          if (estimate) {
            details.pop(); // Replace the generic inquiry with this brand's confirmed-stock rule.
            details.push(orderWindowText(estimate.deadline, opts.now));
            details.push('メーカー出荷目安：' + formatDisplayDate(estimate.date) + (estimate.latestDate ? '～' + formatDisplayDate(estimate.latestDate) : ''));
          }
        }
        return 'メーカー直送\n' + details.join('\n') + '\n' + directEstimateNote(opts);
      }
      const estimate = getBrandDirectEstimate(rule, opts.now);
      const delivery = estimate ? orderWindowText(estimate.deadline, opts.now).replace(/ご注文で$/, 'ご注文の場合') + '\nメーカー出荷目安：在庫がある場合、' + (estimate.latestDate ? '' : '最短で') + formatDisplayDate(estimate.date) + (estimate.latestDate ? '～' + formatDisplayDate(estimate.latestDate) : '') + '頃' : '納期お問い合わせください';
      return 'メーカー直送\n' + delivery + '\n' + rule.stockNote + directEstimateNote(opts);
    }
    return getManufacturerStockText(opts.manufacturerStock, opts.now);
  }

  function acousticCutRoutePending(opts) {
    if (String(opts.vendor || '').replace(/[\s　]/g, '').toLowerCase() !== 'acousticrevive') return '';
    const id = String(opts.variantId || '');
    // Common physical-stock API is not connected. Never treat per-variant stock or demo zero as common stock.
    if (['49394325815575','49394329583895','49394329649431','54762534076695','49362961760535'].includes(id)) return '当店へ取り寄せ後に出荷（0.5m単位）';
    if (['49394325848343','49394329616663','49394329682199','54762534109463','49362961793303'].includes(id)) return 'メーカー直送（1m単位）';
    return '';
  }
  function acousticCutPendingText(opts, route) {
    const maker = getManufacturerStockText(opts.manufacturerStock, opts.now);
    return '店頭共通在庫・納期確認中\n' + (maker ? maker + '\n' : '') + '店頭共通在庫を超える場合：' + route + '\n必要長を同一在庫から確保できるか確認のうえ、正式な納期をご案内します。';
  }
  function isAcousticCustomOrder(opts) {
    return String(opts.vendor || '').replace(/[\s　]/g, '').toLowerCase() === 'acousticrevive' && opts.manufacturerStock?.supplier === 'acoustic_revive_kanjitsu' && opts.manufacturerStock.fulfillment === 'made_to_order';
  }
  function acousticCustomOrderText() {
    return '受注生産\n通常納期3～4週間程度\n納期は目安であり確約ではありません。正式な出荷予定は手配後にご案内します。';
  }
  function isMadeToOrder(opts) {
    return isAcousticCustomOrder(opts) || opts.madeToOrder === true || /受注生産/.test([opts.shippingNote, opts.deliveryNote].join('').replace(/[\s　]/g, ''));
  }
  function isStoreStockOnly(opts) {
    const stock = opts.manufacturerStock;
    return stock?.status === 'unavailable' && /生産完了|生産終了|製造終了/.test(String(stock.next_arrival || ''));
  }
  function getEstimateText(opts) {
    // Untracked inventory is not evidence of stock held by our store.
    if (opts.inventoryTracked === false) opts = { ...opts, inventory: 0 };
    const cutRoute = acousticCutRoutePending(opts);
    if (cutRoute) return acousticCutPendingText(opts, cutRoute);
    if (isStoreStockOnly(opts)) {
      const inventory = Math.max(0, Number(opts.inventory || 0));
      const quantity = Math.max(1, Number(opts.quantity || 1));
      if (!inventory) return '生産完了・当店在庫なし\n再入荷予定はありません。';
      const estimate = getStockShippingEstimate(opts.now);
      if (opts.inventoryTracked !== false && quantity > inventory) return '生産完了・店頭在庫限り\nご注文数量が店頭在庫数を超えています。追加のお取り寄せはできません。\n数量を店頭在庫数以下に変更してください。';
      return '店頭在庫あり（生産完了・店頭在庫限り）\n' + estimate.message + '\n在庫がなくなり次第、販売終了となります。';
    }
    if (isMadeToOrder(opts)) {
      if (!isAcousticCustomOrder(opts)) return '在庫状況・納期お問い合わせ';
      const inventory = Math.max(0, Number(opts.inventory || 0));
      const quantity = Math.max(1, Number(opts.quantity || 1));
      const storeEligible = inventory > 0;
      if (storeEligible && inventory > 0) {
        const estimate = getStockShippingEstimate(opts.now);
        if (opts.inventoryTracked === false || quantity <= inventory) return '店頭在庫あり\n' + estimate.message;
        return '店頭在庫分：' + inventory + '点\n' + estimate.message + '\n受注生産分：' + (quantity - inventory) + '点\n' + acousticCustomOrderText();
      }
      return acousticCustomOrderText();
    }

    const rawType = (opts.shippingType || '').trim();

    const note = (opts.shippingNote || '').trim();

    const inv = Number(opts.inventory);

    const context = opts.context || 'product';



    if (opts.cutCable === true && opts.inventoryTracked !== false && Number(opts.quantity || 1) > Math.max(0, inv)) {
      const manufacturerText = getExternalStockText(opts);
      const direct = isBrandDirect(opts);
      if (direct && manufacturerText) {
        const lines = manufacturerText.split('\n');
        lines.splice(1, 0, '店頭在庫数を超えるため、全数直送となります。');
        return lines.join('\n');
      }
      const title = direct ? '全数メーカー直送で手配' : '全数お取り寄せ・メーカー直送で手配';
      const explanation = direct ? 'ご注文数量が店頭在庫を超えるため、全数をメーカー直送で手配します。' : 'ご注文数量が店頭在庫を超えるため、全数をお取り寄せ、またはメーカー直送で手配します。';
      return title + '\n' + explanation + '\n' + (manufacturerText || '納期お問い合わせください');
    }

    var resolved = '';

    if (inv > 0) {

      resolved = 'stock';

    } else if (rawType === 'メーカー直送') {

      resolved = 'direct';

    } else if (rawType === 'お取り寄せ') {

      resolved = 'inquiry';

    } else if (rawType) {

      resolved = 'inquiry'; // 想定外の値

    } else {

      // メタフィールド空 → 在庫で判定

      resolved = (inv > 0) ? 'stock' : 'inquiry';

    }



    if (resolved === 'stock') {

      const est = getStockShippingEstimate(opts.now);

      const quantity = Number(opts.quantity || 1);
      if (opts.inventoryTracked !== false && quantity > inv && inv > 0) {
        const manufacturerText = getExternalStockText(opts).replace(/^メーカー直送\n/, '');
        const direct = isBrandDirect(opts);
        const externalLabel = direct ? 'メーカー直送分：' : 'お取り寄せ分：';
        const summary = direct ? '店頭在庫分は当店から、メーカー直送分はメーカーから別送となります。' : 'まとめて発送の場合は、すべての商品がそろってからの出荷となります。';
        return '店頭在庫分：' + inv + '点\n' + est.message + '\n' + externalLabel + (quantity - inv) + '点\n' + (manufacturerText || '納期お問い合わせください') + '\n' + summary;
      }
      return '店頭在庫あり\n' + est.message;

    }



    const manufacturerText = getExternalStockText(opts);

    return manufacturerText || note || '納期お問い合わせください';

  }




  // D&M only. Holidays: Cabinet Office, 2026 and 2027.
  // https://www8.cao.go.jp/chosei/shukujitsu/gaiyou.html
  const dmHolidayYears = new Set([2026, 2027]);
  const dmHolidays = new Set(["2026-01-01", "2026-01-12", "2026-02-11", "2026-02-23", "2026-03-20", "2026-04-29", "2026-05-03", "2026-05-04", "2026-05-05", "2026-05-06", "2026-07-20", "2026-08-11", "2026-09-21", "2026-09-22", "2026-09-23", "2026-10-12", "2026-11-03", "2026-11-23", "2027-01-01", "2027-01-11", "2027-02-11", "2027-02-23", "2027-03-21", "2027-03-22", "2027-04-29", "2027-05-03", "2027-05-04", "2027-05-05", "2027-07-19", "2027-08-11", "2027-09-20", "2027-09-23", "2027-10-11", "2027-11-03", "2027-11-23"]);
  const dmEstimateNote = '出荷予定日は目安であり、確約ではありません。メーカーの在庫状況はリアルタイム更新ではないため、受注時の在庫状況や配送事情により出荷が遅れる場合があります。';
  function directEstimateNote(opts) {
    const common = '出荷日は目安であり、確約ではありません。メーカーの在庫状況や受注・手配のタイミング、配送事情により、出荷が遅れる場合があります。';
    return common + (opts.context === 'cart'
      ? '表示の最短出荷目安どおりに出荷する場合は、事前の納期連絡を省略し、出荷連絡をお送りします。遅れる場合は、納期を別途ご案内します。'
      : '正式な出荷予定日は、メーカーへの手配後にご案内します。');
  }

  function getDmShippingEstimate(instant) {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Asia/Tokyo', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(instant || new Date());
    const values = Object.fromEntries(parts.map(function (part) { return [part.type, part.value]; }));
    const today = new Date(Number(values.year), Number(values.month) - 1, Number(values.day));
    const afterCutoff = Number(values.hour) * 60 + Number(values.minute) >= 12 * 60;
    let manufacturerDate = null;
    for (let i = 0; i < 30; i++) {
      const day = new Date(today);
      day.setDate(today.getDate() + i);
      if (!dmHolidayYears.has(day.getFullYear())) return null;
      if (i === 0 && afterCutoff) continue;
      if (day.getDay() === 0 || day.getDay() === 6) continue;
      if (dmHolidays.has(formatDate(day.getFullYear(), day.getMonth(), day.getDate()))) continue;
      manufacturerDate = day;
      break;
    }
    if (!manufacturerDate) return null;
    for (let i = 1; i <= 30; i++) {
      const day = new Date(manufacturerDate);
      day.setDate(manufacturerDate.getDate() + i);
      const info = getDayType(day.getFullYear(), day.getMonth(), day.getDate());
      if (!isShippingDay(info.type)) continue;
      return { manufacturerDate: manufacturerDate, arrivalDate: day, date: day, displayDate: formatDisplayDate(day) };
    }
    return null;
  }

  function getManufacturerStockText(stock, now) {

    if (!stock || !['naspec', 'dm', 'ortofon', 'phasemation', 'harman', 'acoustic_revive_kanjitsu'].includes(stock.supplier)) return '';

    const labels = {

      available: 'メーカー在庫あり',

      limited: 'メーカー在庫僅少',

      unavailable: 'メーカー在庫なし'

    };

    const parts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(stock.date || '');

    if (!labels[stock.status] || !parts) return '';

    const date = parts[1] + '年' + Number(parts[2]) + '月' + Number(parts[3]) + '日';

    const arrival = ['limited', 'unavailable'].includes(stock.status) && typeof stock.next_arrival === 'string' ? stock.next_arrival.trim() : '';
    const arrivalLine = arrival ? '\n次回入荷：' + arrival.replace(/^次回入荷[：:]?\s*/, '') : '';
    let deliveryLine = '\n納期お問い合わせください';
    const isDmEstimate = stock.supplier === 'dm' && ['available', 'limited'].includes(stock.status);
    if (isDmEstimate) {
      const estimate = getDmShippingEstimate(now);
      if (estimate) {
        const deadline = new Date(estimate.manufacturerDate);
        deadline.setHours(12, 0, 0, 0);
        deliveryLine = '\n' + orderWindowText(deadline, now) + '\n当店出荷予定：' + estimate.displayDate;
      }
    }
    const noteLine = stock.supplier === 'dm' && deliveryLine.includes('当店出荷予定：') ? '\n' + dmEstimateNote : '';
    return 'お取り寄せ（' + labels[stock.status] + '）　（確認日 ' + date + '）' + arrivalLine + deliveryLine + noteLine;

  }



  /**

   * 告知バー用：本日の営業状況テキスト

   */

  function getTodayStatusText(now) {

    now = now || new Date();

    const y = now.getFullYear();

    const m = now.getMonth();

    const d = now.getDate();

    const info = getDayType(y, m, d);



    const statusMap = {

      store:  '本日は通常営業です（10:00〜12:30 / 14:00〜18:00）',

      short:  '本日は時短営業です',

      phone:  '本日は店舗休業です（電話・メール対応、直送のみ）',

      closed: '本日は休業日です'

    };



    let text = statusMap[info.type] || '本日の営業状況をご確認ください';



    // 時短の場合は時間も付ける

    if (info.type === 'short' && info.label) {

      const clean = String(info.label)

        .replace(/<br\s*\/?>/gi, ' ')

        .replace(/<\/?strong>/gi, '');

      text = '本日は時短営業です（' + clean + '）';

    }



    // 電話対応日で時間がデフォルトと違う場合

    if (info.type === 'phone' && info.label && info.label !== typeLabels.phone) {

      const clean = String(info.label)

        .replace(/<br\s*\/?>/gi, ' ')

        .replace(/<\/?strong>/gi, '');

      text = '本日は店舗休業です（電話対応 ' + clean + '）';

    }



    return {

      type: info.type,

      text: text

    };

  }

  function isBankReceiptDay(date) {
    return dmHolidayYears.has(date.getFullYear()) && date.getDay() !== 0 && date.getDay() !== 6 && !dmHolidays.has(formatDate(date.getFullYear(),date.getMonth(),date.getDate())) && isShippingDay(getDayType(date.getFullYear(),date.getMonth(),date.getDate()).type);
  }
  function getCollectionShippingEstimate(makerEstimate, config) {
    if (!makerEstimate?.date || config?.confirmed !== true || !Number.isInteger(config.transitDays) || config.transitDays < 0 || config.transitDays > 30) return null;
    if (!['next-business-day','same-day-before-cutoff'].includes(config.dispatchTiming)) return null;
    if (config.dispatchTiming === 'same-day-before-cutoff' && config.receiptMinute != null && (!Number.isInteger(config.receiptMinute) || config.receiptMinute < 0 || config.receiptMinute >= 1440)) return null;
    function fromDispatch(dispatch, latest) {
      let receipt = new Date(dispatch.getFullYear(),dispatch.getMonth(),dispatch.getDate()+config.transitDays,12);
      let found = false;
      for(let i=0;i<30;i++){
        if(isShippingDay(getDayType(receipt.getFullYear(),receipt.getMonth(),receipt.getDate()).type)){found=true;break;}
        receipt.setDate(receipt.getDate()+1);
      }
      if(!found)return null;
      const dispatchDay = new Date(receipt);
      if(config.dispatchTiming === 'next-business-day')dispatchDay.setDate(dispatchDay.getDate()+1);
      // Unknown arrival time spans before/after the dispatch cutoff. Keep the
      // earliest possibility, but use the latest date for delivery selection.
      const minute=config.dispatchTiming === 'next-business-day' ? 0 : config.receiptMinute ?? (latest ? 1439 : 0);
      const instant=new Date(formatDate(dispatchDay.getFullYear(),dispatchDay.getMonth(),dispatchDay.getDate())+'T'+pad(Math.floor(minute/60))+':'+pad(minute%60)+':00+09:00');
      return {receiptDate:receipt,date:getStockShippingEstimate(instant).date};
    }
    const first=fromDispatch(makerEstimate.date,false),last=fromDispatch(makerEstimate.latestDate || makerEstimate.date,true);
    if(!first?.date || !last?.date)return null;
    return {date:first.date,latestDate:last.date,receiptDate:first.receiptDate,latestReceiptDate:last.receiptDate};
  }
  function getLineShippingPlan(opts) {
    const quantity = Math.max(0, Number(opts.quantity || 0));
    if (!quantity || opts.requiresShipping === false) return [];
    const inventory = Math.max(0, Number(opts.inventory || 0));
    const raw = String(opts.shippingType || '').trim();
    const tracked = opts.inventoryTracked !== false;
    const storeEligible = tracked && inventory > 0;
    const storeQuantity = storeEligible ? Math.min(quantity, inventory) : 0;
    const parts = [];
    const make = (qty, source, estimate, reason) => ({quantity:qty, source, date:estimate?.date || null, latestDate:estimate?.latestDate || estimate?.date || null, reason:reason || '', title:opts.title || '', lineKey:opts.lineKey || '', variantId:String(opts.variantId || '')});
    const cutRoute = acousticCutRoutePending(opts);
    if (cutRoute) return [make(quantity, cutRoute.startsWith('メーカー直送') && opts.paymentMode !== 'cod' && opts.consolidate !== true ? 'direct:' + (opts.dispatchOriginLabel || opts.vendor || opts.variantId) : 'store', null, acousticCutPendingText(opts, cutRoute))];
    if (isStoreStockOnly(opts)) {
      if (storeQuantity) parts.push(make(storeQuantity, 'store', getStockShippingEstimate(opts.storeStockReadyAt || opts.now), '生産完了・店頭在庫限り'));
      if (quantity > storeQuantity) parts.push(make(quantity - storeQuantity, 'store', null, inventory > 0 ? '店頭在庫数を超えています。生産完了のため追加のお取り寄せはできません。数量を変更してください。' : '生産完了・当店在庫なし。再入荷予定はありません。'));
      return parts;
    }
    if (isMadeToOrder(opts)) {
      if (!isAcousticCustomOrder(opts)) return [make(quantity, 'store', null, '在庫状況・納期お問い合わせ')];
      if (storeQuantity) parts.push(make(storeQuantity, 'store', getStockShippingEstimate(opts.storeStockReadyAt || opts.now)));
      if (quantity > storeQuantity) parts.push(make(quantity - storeQuantity, 'store', null, acousticCustomOrderText()));
      return parts;
    }
    if (storeQuantity && !(opts.cutCable && storeQuantity < quantity)) {
      // Bank receipts checked just after the normal cutoff are explicitly
      // eligible for same-day STORE-STOCK dispatch. Supplier cutoffs stay intact.
      parts.push(make(storeQuantity, 'store', getStockShippingEstimate(opts.storeStockReadyAt || opts.now)));
    }
    const externalQuantity = opts.cutCable && storeQuantity < quantity ? quantity : quantity - storeQuantity;
    if (!externalQuantity) return parts;
    const direct = opts.manufacturerStock?.supplier !== 'dm' && (isBrandDirect(opts) || raw === 'メーカー直送');
    const codCollection = direct && (opts.paymentMode === 'cod' || opts.consolidate === true);
    const source = direct && !codCollection ? 'direct:' + (opts.dispatchOriginLabel || opts.vendor || opts.variantId) : 'store';
    const stock = opts.manufacturerStock;
    const stockAvailable = stock && /^(\d{4})-(\d{2})-(\d{2})$/.test(stock.date || '') && ['available','limited'].includes(stock.status) && !/予約順/.test(stock.next_arrival || '');
    if (String(opts.deliveryNote || '').trim()) {
      parts.push({...make(externalQuantity, source, null, String(opts.deliveryNote).trim()),...(codCollection?{routing:'collect-at-store',originalSource:'direct:'+(opts.vendor||opts.variantId)}:{})});
    } else if (codCollection) {
      const rule=getBrandDeliveryRule(opts);
      const makerEstimate=rule?.stockKnown && stockAvailable && stock.supplier === (rule.stockSupplier || 'phasemation') ? getBrandDirectEstimate(rule, opts.now) : null;
      const config=opts.collectionRules?.suppliers?.[stock?.supplier] || opts.collectionRules?.default;
      // Reuse maker dispatch rules, then add transport to our store, business-day
      // receipt and the confirmed handling schedule. DM already includes inbound.
      const estimate = stockAvailable && stock.supplier === 'dm' ? getDmShippingEstimate(opts.now) : getCollectionShippingEstimate(makerEstimate,config);
      parts.push({...make(externalQuantity, source, estimate, estimate ? '' : (opts.paymentMode==='cod'?'代引きのため':'店頭に集約するため')+'当店へ取り寄せ後に出荷します。入荷・出荷予定は確認後にご案内します。'), routing:'collect-at-store', originalSource:'direct:' + (opts.vendor || opts.variantId),receiptDate:estimate?.receiptDate || estimate?.arrivalDate || null});
    } else if (direct) {
      const rule = getBrandDeliveryRule(opts);
      const estimate = rule?.stockKnown && stockAvailable && stock.supplier === (rule.stockSupplier || 'phasemation') ? getBrandDirectEstimate(rule, opts.now) : null;
      parts.push(make(externalQuantity, source, estimate, estimate ? '' : 'メーカー在庫・出荷日を確認後にご案内します。'));
    } else {
      const estimate = stockAvailable && stock.supplier === 'dm' ? getDmShippingEstimate(opts.now) : null;
      parts.push(make(externalQuantity, source, estimate, estimate ? '' : '入荷・出荷予定を確認後にご案内します。'));
    }
    return parts;
  }

  return {

    // データ参照用（カレンダーから使う）

    defaultByWeekday: defaultByWeekday,

    overrides: overrides,

    typeLabels: typeLabels,



    // 関数

    getDayType: getDayType,

    getStockShippingEstimate: getStockShippingEstimate,

    getEstimateText: getEstimateText,
    getLineShippingPlan: getLineShippingPlan,
    getCutoffMinutes: getCutoffMinutes,
    isBankReceiptDay: isBankReceiptDay,

    getTodayStatusText: getTodayStatusText,
    getDmShippingEstimate: getDmShippingEstimate,
    getMaceShippingEstimate: getMaceShippingEstimate,
    brandDeliveryRules: brandDeliveryRules,

    isShippingDay: isShippingDay,

    formatDate: formatDate

  };

})();


// Hide the fallback excerpt when Teramoto's original Judge.me review is present.
(function () {
  function syncAudioNoteExcerpt() {
    const hasOriginal = Array.from(document.querySelectorAll('.jdgm-rev-widg .jdgm-rev')).some(function (review) {
      const author = review.querySelector('.jdgm-rev__author');
      const body = review.querySelector('.jdgm-rev__body');
      const name = author ? author.textContent.normalize('NFKC').replace(/\s/g, '').replace(/さん$/, '') : '';
      return name === '寺本清輝' && body && body.textContent.trim() && review.getClientRects().length > 0 && getComputedStyle(review).display !== 'none';
    });
    document.querySelectorAll('.audio-note-product-link').forEach(function (excerpt) {
      if (excerpt.hidden !== hasOriginal) excerpt.hidden = hasOriginal;
      if (hasOriginal) excerpt.style.setProperty('display', 'none', 'important');
      else excerpt.style.removeProperty('display');
    });
  }
  function start() {
    let timer;
    const observer = new MutationObserver(function (changes) {
      if (changes.every(function (c) { return c.target.nodeType === 1 && c.target.matches('.audio-note-product-link'); })) return;
      clearTimeout(timer); timer = setTimeout(syncAudioNoteExcerpt, 100);
    });
    observer.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['class','style','hidden']});
    syncAudioNoteExcerpt();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();


// Keep the legacy stock-category line consistent with the selected variant.
(function () {
  function syncStockCategory() {
    const estimate = document.querySelector('#shipping-estimate-product .shipping-estimate__text');
    if (!estimate) return;
    const text = estimate.textContent.trim();
    const category = text.startsWith('生産完了・店頭在庫限り') ? '生産完了・店頭在庫限り'
      : text.startsWith('生産完了・当店在庫なし') ? '生産完了・当店在庫なし'
      : text.startsWith('店頭在庫あり（生産完了') ? '生産完了・店頭在庫限り'
      : text.startsWith('店頭在庫分：') ? (text.includes('メーカー直送分：') ? '店頭在庫＋メーカー直送' : '店頭在庫＋お取り寄せ')
      : text.startsWith('店頭在庫あり') ? '店頭在庫'
      : text.startsWith('メーカー直送（在庫状況未確認）') || text.startsWith('全数メーカー直送で手配') ? 'メーカー直送'
      : text.startsWith('お取り寄せ（QR-8ばら売り') ? 'お取り寄せ'
      : text.startsWith('全数お取り寄せ・メーカー直送で手配') ? 'お取り寄せ・メーカー直送'
      : text.startsWith('お取り寄せ（メーカー在庫') ? 'お取り寄せ' : '';
    if (!category) return;
    document.querySelectorAll('#MainContent .product__text').forEach(function (line) {
      if (!line.textContent.trim().startsWith('在庫区分')) return;
      const label = line.querySelector('strong');
      if (label && label.textContent !== category) label.textContent = category;
    });
  }
  function start() {
    const root = document.getElementById('MainContent');
    if (!root) return;
    new MutationObserver(syncStockCategory).observe(root, { childList: true, subtree: true, characterData: true });
    syncStockCategory();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

// Present the selected variant's existing shipping text as a compact information card.
(function () {
  function start() {
    if (!document.getElementById('core-stock-card-style')) {
      const style = document.createElement('style');
      style.id = 'core-stock-card-style';
      style.textContent = `
        :is(#shipping-estimate-product, .shipping-estimate--cart).shipping-estimate {margin:18px 0 14px;padding:0;border:0;color:#243e57;font-weight:400;}
        :is(#shipping-estimate-product, .shipping-estimate--cart) .shipping-estimate__text {display:block;box-sizing:border-box;width:100%;padding:17px 19px;border:1px solid #cdd9e4;border-left:4px solid #3b617f;border-radius:10px;background:#f5f8fb;color:#243e57;font-family:inherit;font-size:14px;font-weight:400;line-height:1.6;white-space:normal;overflow-wrap:anywhere;}
        :is(#shipping-estimate-product, .shipping-estimate--cart) .shipping-estimate__text[data-stock-kind="store"] {border-color:#c9ddd4;border-left-color:#39745c;background:#f5faf7;}
        :is(#shipping-estimate-product, .shipping-estimate--cart) .core-stock-header {display:block;margin-bottom:11px;}
        :is(#shipping-estimate-product, .shipping-estimate--cart) .core-stock-heading {display:inline-block;padding:4px 10px;border-radius:5px;background:#e2ebf3;color:#294c68;font-size:14px;font-weight:700;line-height:1.5;}
        :is(#shipping-estimate-product, .shipping-estimate--cart) [data-stock-kind="store"] .core-stock-heading {background:#e0eee6;color:#285a43;}
        :is(#shipping-estimate-product, .shipping-estimate--cart) .core-stock-confirmed {display:block;margin-top:6px;color:#6b7785;font-size:13px;font-weight:400;line-height:1.5;}
        :is(#shipping-estimate-product, .shipping-estimate--cart) .core-stock-arrival {display:block;margin-bottom:10px;color:#46566a;font-size:14px;font-weight:400;}
        :is(#shipping-estimate-product, .shipping-estimate--cart) .core-stock-date {display:block;color:#1c354a;font-size:23px;font-weight:700;line-height:1.4;letter-spacing:.01em;}
        :is(#shipping-estimate-product, .shipping-estimate--cart) .core-stock-date-label {display:block;margin-top:3px;margin-bottom:2px;color:#53687c;font-size:14px;font-weight:500;letter-spacing:.03em;}
        :is(#shipping-estimate-product, .shipping-estimate--cart) .core-stock-store-date {display:block;color:#244e3b;font-size:18px;font-weight:700;line-height:1.55;}
        :is(#shipping-estimate-product, .shipping-estimate--cart) .core-stock-inquiry {display:block;color:#344f67;font-size:15px;font-weight:600;}
        :is(#shipping-estimate-product, .shipping-estimate--cart) .core-stock-note {display:block;margin-top:13px;padding-top:11px;border-top:1px solid #dce4eb;color:#67717d;font-size:13px;font-weight:400;line-height:1.7;}
        :is(#shipping-estimate-product, .shipping-estimate--cart) .shipping-estimate__text[data-stock-kind="plain"] {padding:0;border:0;border-radius:0;background:none;color:inherit;font-size:16px;font-weight:500;}
        :is(#shipping-estimate-product, .shipping-estimate--cart) .shipping-estimate__text[data-inquiry-only="true"] {color:#c62828;font-weight:700;}
        :is(#shipping-estimate-product, .shipping-estimate--cart) .core-stock-order-window {display:block;margin-bottom:4px;color:#344f67;font-size:15px;font-weight:600;}
        :is(#shipping-estimate-product, .shipping-estimate--cart) .core-stock-inquiry-red {color:#c62828;font-size:16px;font-weight:700;}
        :is(#shipping-estimate-product, .shipping-estimate--cart) .shipping-estimate__text[data-stock-kind="mixed"] {padding:0;border:0;background:none;}
        .core-stock-split-section {display:block;padding:15px 18px;border:1px solid #cdd9e4;border-left:4px solid #3b617f;border-radius:10px;background:#f5f8fb;}
        .core-stock-split-section[data-stock-part="store"] {margin-bottom:12px;border-color:#c9ddd4;border-left-color:#39745c;background:#f5faf7;}
        .core-stock-split-section[data-stock-part="store"] .core-stock-heading {background:#e0eee6;color:#285a43;}
        .core-stock-split-section .core-stock-heading {margin-bottom:8px;}
        .core-stock-split-section .core-stock-inquiry {font-size:14px;font-weight:400;margin-bottom:5px;}
        .core-stock-split-section .core-stock-inquiry-red {color:#c62828;font-size:16px;font-weight:700;}
        @media(min-width:990px) {#main-cart-items .cart-item__details > .shipping-estimate--cart {max-width:none;width:100%;}}
        @media(max-width:749px) {:is(#shipping-estimate-product, .shipping-estimate--cart) .shipping-estimate__text {padding:15px 15px;}:is(#shipping-estimate-product, .shipping-estimate--cart) .core-stock-date {font-size:21px;}:is(#shipping-estimate-product, .shipping-estimate--cart) .core-stock-store-date {font-size:17px;}}
      `;
      style.textContent += '@media(max-width:749px){:is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-confirmed{display:block;white-space:nowrap;font-size:13px;font-weight:400;margin:2px 0 0}:is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-header{flex-direction:column;align-items:flex-start;gap:2px}}';
      style.textContent += '\n.core-stock-date-conditional{font-size:16px!important;font-weight:500!important;line-height:1.6!important}.core-stock-date-conditional .core-stock-date-label{font-size:13px!important;font-weight:400!important}';
      style.textContent += '\n.shipping-estimate--cart .core-stock-inquiry{font-weight:400;color:#334155;line-height:1.7}\n.shipping-estimate--cart .core-stock-note{font-weight:400;color:#64748b;line-height:1.6}\n.shipping-estimate--cart .core-stock-heading{color:#1e4e70;font-weight:700}\n.shipping-estimate--cart [data-stock-part=store] .core-stock-heading{color:#235d39}\n.shipping-estimate--cart .core-stock-order-window{font-weight:500;color:#356586}\n.shipping-estimate--cart .core-stock-arrival{font-weight:600;color:#1e4e70}\n.shipping-estimate--cart .core-stock-date-conditional{color:#356586}\n.cart-item__details>.caption-with-letter-spacing{color:#64748b}\n.cart-item__details>.cart-item__name{color:#172b3a}\n.cart-item__details>dl{color:#475569}\n.cart-item__details>.product-option{color:#172b3a;font-weight:600}\n.cart-item__details .core-stock-inquiry-red{color:#c62828;font-weight:700}\n';
      style.textContent += `
        :is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-source{display:block;margin:0 0 10px;padding-bottom:8px;border-bottom:1px solid #d9e3ec;color:#566575;font-size:14px;font-weight:400;line-height:1.6}
        :is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-available{color:#07502c;font-weight:700}
        :is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-limited{color:#694000;font-weight:700}
        :is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-unavailable{color:#990f22;font-weight:700}
        :is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-route-date{display:block;margin:10px 0 2px;padding:9px 11px;border-left:3px solid #c38a23;border-radius:4px;background:#fff4da;color:#795000;font-size:15px;font-weight:600;line-height:1.6}
        :is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-note{margin-top:13px;padding:11px 12px;border:0;border-radius:6px;background:#edf1f5;color:#536170;font-size:14px;font-weight:400;line-height:1.75}
        :is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-order-window{color:#3c5871;margin-top:8px;margin-bottom:6px}
        :is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-date{color:#073b69}
        :is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-source,:is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-confirmed,:is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-date-label{color:#303b49}
        :is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-note{color:#273341}
        :is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-order-window{color:#193d5d}
        :is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-route-date{color:#603b00}
        :is(#shipping-estimate-product,.shipping-estimate--cart) [data-stock-part=store] .core-stock-date,:is(#shipping-estimate-product,.shipping-estimate--cart) [data-stock-kind=store] .core-stock-date{color:#244e3b}
        @media(max-width:749px){:is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-route-date{padding:9px 10px}:is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-note{padding:10px 11px}}
        :is(#shipping-estimate-product,.shipping-estimate--cart) .shipping-estimate__text:not([data-stock-kind=plain]):not([data-stock-kind=mixed]),:is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-split-section{border-left-color:#1673d1;background:#f0f7ff}
        :is(#shipping-estimate-product,.shipping-estimate--cart) .shipping-estimate__text[data-stock-kind=store],:is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-split-section[data-stock-part=store]{border-left-color:#00966b;background:#effbf5}
        :is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-heading{background:#1263b4;color:#fff;padding:5px 11px}
        :is(#shipping-estimate-product,.shipping-estimate--cart) [data-stock-part=store] .core-stock-heading,:is(#shipping-estimate-product,.shipping-estimate--cart) [data-stock-kind=store] .core-stock-heading{background:#087b58;color:#fff}
        :is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-date{color:#0754a0}
        :is(#shipping-estimate-product,.shipping-estimate--cart) [data-stock-part=store] .core-stock-date,:is(#shipping-estimate-product,.shipping-estimate--cart) [data-stock-kind=store] .core-stock-date{color:#006b49}
        :is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-route-date{background:#fff0db;border-left-color:#ee8500;color:#854000}
        :is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-route-label{display:block;font-size:14px;font-weight:500}
        :is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-route-value{display:block;font-size:18px;font-weight:700;white-space:nowrap;line-height:1.65}
        :is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-note{background:#fff;border:1px solid #dce1ed;border-left:3px solid #8b83c4;color:#273341}
        @media(max-width:749px){
          :is(#shipping-estimate-product,.shipping-estimate--cart) .shipping-estimate__text:not([data-stock-kind=plain]):not([data-stock-kind=mixed]),:is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-split-section{padding:15px 13px;font-size:15px;line-height:1.75}
          :is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-heading{font-size:15px}
          :is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-source{line-height:1.7;margin-bottom:12px}
          :is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-order-window{font-size:15px;line-height:1.65;margin-top:11px}
          :is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-date{font-size:23px;margin-bottom:4px}
          :is(#shipping-estimate-product,.shipping-estimate--cart) .core-stock-note{padding:11px 12px;font-size:14px;line-height:1.85;overflow-wrap:break-word;word-break:normal}
          .cart-item__details>.caption-with-letter-spacing{font-size:12px;color:#3a4a5c}
          .cart-item__details>dl .product-option{font-size:14px;line-height:1.65}
        }
      `;
      document.head.append(style);
    }
    function separateConfirmation(element, text) {
      const match = /^(.*?)\s*（確認日 ([^）]+)）$/.exec(text);
      if (!match || !match[1].trim()) return;
      const date = document.createElement('span');
      date.className = 'core-stock-confirmed';
      date.textContent = '（確認日 ' + match[2] + '）';
      element.replaceChildren(document.createTextNode(text.slice(0, text.indexOf('（確認日 '))), date);
    }
    function breakNoteSentences(element, line) {
      const sentences = line.match(/[^。]+。|[^。]+$/g) || [line];
      const nodes = [];
      sentences.forEach(function (sentence, index) {
        if (index) nodes.push(document.createElement('br'));
        nodes.push(document.createTextNode(sentence));
      });
      element.replaceChildren(...nodes);
    }
    function decorateStockDetail(element, line) {
      if (line.startsWith('直送元：')) element.classList.add('core-stock-source');
      if (line.startsWith('メース経由の場合の出荷予定：')) {
        element.classList.add('core-stock-route-date');
        const label = document.createElement('span');
        label.className = 'core-stock-route-label';
        label.textContent = 'メース経由の場合の出荷予定：';
        const value = document.createElement('span');
        value.className = 'core-stock-route-value';
        value.textContent = line.slice(label.textContent.length);
        element.replaceChildren(label, value);
      }
      if (/^メーカー在庫あり/.test(line)) element.classList.add('core-stock-available');
      if (/^メーカー在庫(?:僅少|極少)/.test(line)) element.classList.add('core-stock-limited');
      if (/^メーカー在庫なし/.test(line)) element.classList.add('core-stock-unavailable');
    }
    function renderSplit(target, raw) {
      if (target.dataset.cardText === raw && target.firstElementChild?.classList.contains('core-stock-split-section')) return;
      const lines = raw.split('\n');
      const fragment = document.createDocumentFragment();
      let section = null;
      const make = function (name, text) {const el = document.createElement('span');el.className = name;el.textContent = text;separateConfirmation(el, text);decorateStockDetail(el, text);return el;};
      lines.forEach(function (line, index) {
        if (index) {
          const separatorParent = /^(店頭在庫分：|お取り寄せ分：|メーカー直送分：|まとめて発送の場合|店頭在庫分は当店から)/.test(line) ? fragment : section;
          separatorParent.append(document.createTextNode('\n'));
        }
        if (/^(店頭在庫分：|お取り寄せ分：|メーカー直送分：)/.test(line)) {
          section = make('core-stock-split-section', '');
          section.dataset.stockPart = line.startsWith('店頭在庫分：') ? 'store' : 'manufacturer';
          section.append(make('core-stock-heading', line));
          fragment.append(section);
        } else {
          const parent = (line.startsWith('まとめて発送の場合') || line.startsWith('店頭在庫分は当店から')) ? fragment : section;
          let el;
          if (/^(当店出荷予定：|メーカー出荷目安：)/.test(line)) {
            el = make(line.startsWith('メーカー出荷目安：') && !/メーカー在庫(?:あり|僅少)/.test(raw) ? 'core-stock-date core-stock-date-conditional' : 'core-stock-date', '');
            const label = line.startsWith('メーカー出荷目安：') ? 'メーカー出荷目安：' : '当店出荷予定：';
            el.append(make('core-stock-date-label',label),document.createTextNode(line.slice(label.length)));
          } else {
            const name = line === '納期お問い合わせください' ? 'core-stock-inquiry-red'
              : /^(次回入荷：|メーカー入荷予定：|メース経由の場合の出荷予定：)/.test(line) ? 'core-stock-arrival'
              : /^(国内仕入先（メース・完実電気など）経由|出荷予定日は目安|出荷日は目安|メーカーに在庫がある場合の目安|納期は目安|メーカーへの在庫確認後|在庫確認後に)/.test(line) || (line.startsWith('まとめて発送の場合') || line.startsWith('店頭在庫分は当店から')) ? 'core-stock-note'
              : /^(あと|本日).*ご注文(?:で|の場合)$/.test(line) ? 'core-stock-order-window'
              : section?.dataset.stockPart === 'store' ? 'core-stock-store-date' : 'core-stock-inquiry';
            el = make(name, line);
            if (name === 'core-stock-note') breakNoteSentences(el, line);
          }
          parent.append(el);
        }
      });
      target.dataset.stockKind = 'mixed';
      delete target.dataset.inquiryOnly;
      target.dataset.cardText = raw;
      target.replaceChildren(fragment);
    }
    function renderTarget(target) {
      const product = target.closest('#shipping-estimate-product');
      if (product && window.BusinessShipping) {
        let variants = [];
        try { variants = JSON.parse(document.getElementById('ShippingEstimateVariants').textContent); } catch (e) {}
        const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
        const id = input && input.value ? input.value : product.dataset.selectedVariant;
        const selected = variants.find(function (v) { return String(v.id) === String(id); });
        const text = window.BusinessShipping.getEstimateText({madeToOrder:product.dataset.madeToOrder === 'true', shippingType:product.dataset.shippingType || '', shippingNote:product.dataset.shippingNote || '', inventory:selected ? (selected.inventory_management ? Number(selected.inventory_quantity) : 0) : Number(product.dataset.inventory || 0), manufacturerStock:selected && selected.manufacturer_stock, deliveryNote:product.dataset.deliveryNote || '', vendor:product.dataset.vendor || '', variantId:id, cutCable:product.dataset.cutCable === 'true', inventoryTracked:selected ? !!selected.inventory_management : true, quantity:Number(product.closest('.product__info-container')?.querySelector('[name="quantity"]')?.value || 1), context:'product'});
        if (target.dataset.cardText === text && target.firstElementChild) return;
        if (target.textContent !== text) target.textContent = text;
      }
      const cart = target.closest('.shipping-estimate--cart');
      if (cart && window.BusinessShipping) {
        let stock = null;
        try { stock = JSON.parse(cart.dataset.manufacturerStock || 'null'); } catch (e) {}
        const scope = cart.closest('cart-items') || cart.parentElement;
        const related = Array.from(scope.querySelectorAll('.shipping-estimate--cart')).filter(function (el) {return el.dataset.variantId === cart.dataset.variantId;});
        const quantity = related.reduce(function (sum, el) {return sum + Number(el.closest('.cart-item')?.querySelector('input[name="updates[]"]')?.value || el.dataset.quantity || 0);}, 0);
        const text = window.BusinessShipping.getEstimateText({
          madeToOrder: cart.dataset.madeToOrder === 'true',
          deliveryNote: cart.dataset.deliveryNote || '', vendor: cart.dataset.vendor || '', variantId: cart.dataset.variantId,
          cutCable: cart.dataset.cutCable === 'true', inventoryTracked: cart.dataset.inventoryTracked !== 'false', quantity: quantity || Number(cart.dataset.quantity || 1),
          shippingType: cart.dataset.shippingType || '', shippingNote: cart.dataset.shippingNote || '',
          inventory: Number(cart.dataset.inventory || 0), manufacturerStock: stock, context: 'cart'
        });
        if (target.dataset.cardText === text && target.firstElementChild) return;
        if (target.textContent !== text) target.textContent = text;
      }
      const raw = target.textContent;
      if (raw.startsWith('店頭在庫分：')) {renderSplit(target, raw); return;}
      if (!/^(メーカー直送|お取り寄せ)(?:\n|（個別納期案内）)/.test(raw.trim()) && !raw.trim().startsWith('店頭在庫あり') && !raw.trim().startsWith('お取り寄せ（メーカー在庫') && !raw.trim().startsWith('全数お取り寄せ・メーカー直送で手配') && !raw.trim().startsWith('全数メーカー直送で手配') && !raw.trim().startsWith('メーカー直送（在庫状況未確認）') && !raw.trim().startsWith('お取り寄せ（QR-8ばら売り')) {
        target.dataset.stockKind = 'plain';
        target.dataset.inquiryOnly = String(['納期お問い合わせください', '在庫状況・納期お問い合わせ'].includes(raw.trim()));
        delete target.dataset.cardText;
        if (target.childElementCount) target.textContent = raw;
        return;
      }
      if (!raw.trim() || (target.dataset.cardText === raw && target.firstElementChild && target.firstElementChild.classList.contains('core-stock-header'))) return;
      const lines = raw.split('\n');
      delete target.dataset.inquiryOnly;
      const fragment = document.createDocumentFragment();
      const make = function (name, value) {const element = document.createElement('span');element.className = name;element.textContent = value;separateConfirmation(element, value);decorateStockDetail(element, value);return element;};
      const header = make('core-stock-header', '');
      const confirmed = lines[0].indexOf('　（確認日 ');
      if (confirmed >= 0) {
        header.append(make('core-stock-heading', lines[0].slice(0, confirmed)), make('core-stock-confirmed', lines[0].slice(confirmed)));
      } else header.append(make('core-stock-heading', lines[0]));
      fragment.append(header);
      lines.slice(1).forEach(function (line) {
        fragment.append(document.createTextNode('\n'));
        if (/^(当店出荷予定：|メーカー出荷目安：)/.test(line)) {
          const date = make(line.startsWith('メーカー出荷目安：') && !/メーカー在庫(?:あり|僅少)/.test(raw) ? 'core-stock-date core-stock-date-conditional' : 'core-stock-date', '');
          const label = line.startsWith('メーカー出荷目安：') ? 'メーカー出荷目安：' : '当店出荷予定：';
          date.append(make('core-stock-date-label', label), document.createTextNode(line.slice(label.length)));
          fragment.append(date);
        } else {
          const name = /^(あと|本日).*ご注文(?:で|の場合)$/.test(line) ? 'core-stock-order-window' : /^(次回入荷：|メーカー入荷予定：|メース経由の場合の出荷予定：)/.test(line) ? 'core-stock-arrival'
            : /^(国内仕入先（メース・完実電気など）経由|出荷予定日は目安|出荷日は目安|メーカーに在庫がある場合の目安|納期は目安|メーカーへの在庫確認後|在庫確認後に)/.test(line) ? 'core-stock-note'
            : lines[0].startsWith('店頭在庫あり') ? 'core-stock-store-date' : 'core-stock-inquiry';
          const detail = make(name, line);
          if (line === '納期お問い合わせください') detail.classList.add('core-stock-inquiry-red');
          if (name === 'core-stock-note') breakNoteSentences(detail, line);
          fragment.append(detail);
        }
      });
      target.dataset.stockKind = lines[0].startsWith('店頭在庫あり') ? 'store' : 'manufacturer';
      target.dataset.cardText = raw;
      target.replaceChildren(fragment);
    }
    const root = document.body;
    const observer = new MutationObserver(render);
    function render() {
      // Formatting confirmation dates changes text nodes. Never observe our own writes.
      observer.disconnect();
      try {
        document.querySelectorAll('#shipping-estimate-product .shipping-estimate__text, .shipping-estimate--cart .shipping-estimate__text').forEach(renderTarget);
      } finally {
        if (root) observer.observe(root, {childList:true, subtree:true, characterData:true});
      }
    }
    setInterval(render, 1000);
    document.addEventListener('visibilitychange', render);
    render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();


